import * as yup from 'yup';

import { AmlStatus, KycStatus, UpdateAccountKycAmlStatusRequest } from '@arrived/models';

export const accountKycAmlSchema: yup.SchemaOf<UpdateAccountKycAmlStatusRequest> = yup
  .object({
    userKycStatus: yup
      .mixed<KycStatus>()
      .oneOf([null, ...Object.values(KycStatus)])
      .nullable()
      .defined(),
    userAmlStatus: yup
      .mixed<AmlStatus>()
      .oneOf([null, ...Object.values(AmlStatus)])
      .nullable()
      .defined(),
    entityAmlStatus: yup
      .mixed<AmlStatus>()
      .oneOf([null, ...Object.values(AmlStatus)])
      .nullable()
      .defined(),
  })
  .defined();
